<template>
  <el-form
    ref="preparationForm"
    :model="model"
    label-width="15em"
    label-position="left"
  >
    <el-option v-if='mode !== "this"' label="" value="" />
    <slot></slot>
    <ChargeYear v-model="chargeYear" label="参照年度"  prop="charge_year" yearType = "reference" :required="true" :initialize="true" :tableType = tableType mode = "this" selectedIndex="0"/>
    <ChargeYear v-model="createYear" label="作成年度"  prop="create_year" yearType = "create" :required="true" :initialize="true"  mode = "this" selectedIndex="0"/>
  </el-form>
</template>

<script>
import ChargeYear from '@/components/molecules/form/select/ChargeYear.vue'

export default {
  components: {
    ChargeYear
  },
  model: {
    prop: 'model'
  },
  props: {
    model: Object,
    label: String,
    prop: String,
    yearType: String,
    required: Boolean,
    initialize: Boolean,
    tableType: String,
    mode: String,
    selectedIndex: String,
    action: String
  },
  data () {
    return {
    }
  },
  computed: {
    chargeYear: {
      get () {
        return this.model.charge_year
      },
      set (chargeYear) {
        const form = { ...this.model }
        form.charge_year = chargeYear
        this.$emit('input', form)
      }
    },
    createYear: {
      get () {
        return this.model.create_year
      },
      set (createYear) {
        const form = { ...this.model }
        form.create_year = createYear
        this.$emit('input', form)
      }
    }
  },
  methods: {
    clear () {
      // this.$refs.preparationForm.resetFields()
      // // this.chargeYear = this.getDefaultBillingYm()
      // this.referenceYear = ''
      // this.createYear = ''
    },
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.preparationForm.validate((valid) => {
          if (valid) {
            resolve(valid)
          } else {
            reject(new Error('validate error'))
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.upload {
  display: flex;
  ::v-deep .el-upload {
    order: 2;
  }
  ::v-deep .el-upload-list {
    order: 1;
    width: 100%;
    margin-right: 1em;
    .el-upload-list__item {
      margin-top: 0;
    }
  }
}
</style>
